import { fetchAllData } from "~/services/siteService";

export const useSiteRepository = (hostname: string, url?: any) => {
  const runtimeConfig = useRuntimeConfig();
  const { $pinia } = useNuxtApp();
  const serverHostname = useState<string | null>('server-hostname', () => null);

  const findWebsite = async () => {
    const labelId = getLabelByHostname(hostname)
    const [currentLanguage, availableLanguages] = getCurrentLanguage(url.path, labelId)
    const siteData = await fetchData(currentLanguage, labelId, hostname)

    return siteData
  }

  const getLabelByHostname = (hostname: string) => {
    let dataAll = useDataAll($pinia);
    let runtimeConfigVars = null;

    if (import.meta.client) {
      runtimeConfigVars = runtimeConfig.public;
      if (!hostname) {
        console.log("ERROR: No hostname available on client side");
        return "ERROR";
      }

      if (!isset(runtimeConfig.public.HOSTNAME_SITES) || !isset(runtimeConfig.public.LABELID_SITES)) {
        console.log("ERROR HOSTNAME_SITES NIET GEVONDEN IN public runtime config")
        return "ERROR"
      }

    } 
    else {
      runtimeConfigVars = runtimeConfig
      if (!isset(runtimeConfig.HOSTNAME_SITES) || !isset(runtimeConfig.LABELID_SITES)) {
        console.log("ERROR HOSTNAME_SITES NIET GEVONDEN IN .env, WORDT DE .env FILE GOED INGELADEN")
        throw createError({ statusCode: 500, statusMessage: 'ERROR HOSTNAME_SITES1 NIET GEVONDEN IN .env, WORDT DE .env FILE GOED INGELADEN' })
      }

      // Store hostname in shared state for client-side use
      serverHostname.value = hostname;
      // refactor later
      dataAll.setDataVar('hostname', hostname);
    }

    const labelId = getLabelFromUrl(hostname, runtimeConfigVars)
    if (labelId) {
      dataAll.setlabel(labelId);
      return labelId;
    } else {
      console.log("ERROR " + hostname + " NIET GEVONDEN IN HOSTNAME_SITES")
      return "ERROR"
    }
  }

  if (hostname) {
    return findWebsite()
  }
}

export const isset = (varIn: any) => {
    return (typeof (varIn) != "undefined" && varIn !== null)
}

const fetchData = async (language: string, labelId: string, hostname: string) => {
  const siteData = await fetchAllData(language, labelId, hostname)
  if (siteData.error?.value?.statusCode === 401) {
    throw createError({ statusCode: 401, statusMessage: 'Unauthorized' })
  }
  return siteData.data?.value
}

export const getLabelFromUrl = (url: string, runtimeConfig: any) => {
  if (!url) {
    console.error('URL parameter is required')
    return null
  }

  const sites = runtimeConfig.HOSTNAME_SITES.split(',').map((site: string) => site.trim())
  const sitesId = runtimeConfig.LABELID_SITES.split(',').map((id: string) => id.trim())

  if (sites.length !== sitesId.length) {
    console.error('HOSTNAME_SITES and LABELID_SITES arrays must have same length')
    return null
  }

  let hostname
  try {
    hostname = new URL(url).hostname
  } catch (error) {
    hostname = url
  }

  const index = sites.findIndex((site: string) => site === hostname)

  if (index !== -1) {
    return sitesId[index]
  }

  console.warn(`No label found for hostname: ${hostname}`)
  return null
}

export const getCurrentLanguage = (url: string, labelId: string): [string, string[]] => {
    const runtimeConfig = useRuntimeConfig();
    const { $pinia } = useNuxtApp();
    let languages = ['en', 'nl', 'befr', 'benl', 'de', 'fr']

    let defaultLanguage = 'nl'
    if (runtimeConfig.SITES_DEFAULT_LANGUAGES) {
      let SITES_DEFAULT_LANGUAGES_ARR = runtimeConfig.SITES_DEFAULT_LANGUAGES.split(",");
      for (let index = 0; index < SITES_DEFAULT_LANGUAGES_ARR.length; ++index) {
        let siteDefObj = SITES_DEFAULT_LANGUAGES_ARR[index]
        if (siteDefObj) {
          const siteDefObjSplited = siteDefObj.split(":")
          if (siteDefObjSplited[0] == labelId && siteDefObjSplited[1]) {
            defaultLanguage = siteDefObjSplited[1]
          }
        }
      }
    }

    const parts = url.split("/")
    let languagePart = defaultLanguage;
    if (parts[1]) {
      languagePart = languages.includes(parts[1]) ? parts[1] : defaultLanguage
    }
    useDataAll($pinia).setLanguageObjects([languagePart, languages, defaultLanguage])
    return [languagePart, languages]
  }